import React from 'react';
import {
  Box,
  Typography,
  Stack,
  Button,
} from '@mui/material';
import {
  Link,
} from '@marageti/z4-lib';
import ResetForm from '../../../components/auth/email-reset-link-form';
import { ReactComponent as ZicassoSVG } from '../../../assets/svg/zicasso.svg';
import { ViewProps } from './types';
import '../reset.scss';

const SendLinkView = ({
  onSuccess,
}: ViewProps): React.ReactElement => (
  <Box
    sx={{
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Stack
      spacing={3}
      sx={{
        width: { mobile: '342px', desktop: '333px' },
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Stack flexDirection="column" spacing={2} alignItems="center" width="100%">
        <ZicassoSVG aria-label="Zicasso" />
        <Typography variant="h2">
          Forgot your password?
        </Typography>
        <Typography color="text.secondary" sx={{ textAlign: 'center' }}>
          Please enter your email address and we&apos;ll send you a link to reset your password.
        </Typography>
      </Stack>
      <ResetForm onSuccess={onSuccess} type="reset" />
      <Link
        color="primary"
        sx={{ '&:hover': { color: 'secondary.main' } }}
        to="/login"
        underline="always"
        variant="subtitle1"
      >
        Go back to Sign In
      </Link>
    </Stack>
  </Box>
);

const SubmittedView = ({
  email,
  onClick,
}: { email: string, onClick: () => void }) => (
  <Box
    sx={{
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <Stack
      spacing={3}
      sx={{
        width: { mobile: '342px', desktop: '333px' },
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Stack flexDirection="column" spacing={2} alignItems="center" width="100%">
        <ZicassoSVG aria-label="Zicasso" />
        <Typography variant="h2">
          Please check your email
        </Typography>
        <Typography color="text.secondary" sx={{ textAlign: 'center' }}>
          We&apos;ve sent a reset link to
          <br />
          <Typography component="span" variant="bodyBold">{email}</Typography>
          . Please use the confirmation link in the email to reset your password.
        </Typography>
      </Stack>
      <Stack direction="row" spacing={0.5}>
        <Typography variant="caption" color="primary">
          Didn&apos;t get the email?
        </Typography>
        <Button
          onClick={onClick}
          sx={{
            padding: 0,
            margin: 0,
            border: 'none',
            color: 'primary',
            '&:hover': { background: 'none', color: 'secondary.main' },
          }}
          variant="text"
        >
          <Typography variant="captionUnderline" color="inherit">
            Send Again
          </Typography>
        </Button>
      </Stack>
    </Stack>
  </Box>
);
export { SendLinkView, SubmittedView };
